import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { useTranslation } from "react-i18next";
import Select from 'react-select';
import '../../Assets/scss/components/search-website-dropdown.scss';
import { useTheme } from "../../Context/ThemeContext";
import darkSelectStyles from "../../Helpers/darkSelectStyles";

interface select2PackagePropTypes {
    "value": number,
    "label": string
}

interface PropTypes {
    selectedPackageID: Function // function to set package Id
}

// component to render search package dropdown
const SearchPackageDropdownBlock = (props: PropTypes) => {

    // Props
    const { selectedPackageID } = props;

    const { theme } = useTheme()

    // Function
    const { t } = useTranslation();

    // Redux Data
    const { currentWebsitePlanList, user } = useSelector((store: StoreProptypes) => store);
    const [selectPackageData, setSelectPackageData] = useState<select2PackagePropTypes[]>();
    const [selectedValues, setSelectedValues] = useState<readonly select2PackagePropTypes[]>([]);

    // function to handle package change
    const packageChange = (selectedOptions: readonly select2PackagePropTypes[] | select2PackagePropTypes | null) => {
        if (user?.department === 1) {
            const multiOptions = selectedOptions as readonly select2PackagePropTypes[] | null;
            setSelectedValues(multiOptions || []);
            if (multiOptions && multiOptions.length > 0) {
                const ids = multiOptions.map(opt => opt.value);
                selectedPackageID(ids);
            } else {
                selectedPackageID([]);
            }
        } else {
            const singleOption = selectedOptions as select2PackagePropTypes | null;
            setSelectedValues(singleOption ? [singleOption] : []);
            selectedPackageID(singleOption ? [singleOption.value] : []);
        }
    };
    useEffect(() => {
        if (currentWebsitePlanList && Object.keys(currentWebsitePlanList).length > 0) {
            let temp: select2PackagePropTypes[] = [];

            let allowedKeys = ['free-widget', 'free-license', 'normal', 'multi-store', 'adon'];

            Object.entries(currentWebsitePlanList).forEach(([key, planArray]) => {
                if (allowedKeys.includes(key)) {

                    let filteredPlans = planArray;

                    // 🔥 filter specific names in "adon"
                    if (key === 'adon' && user?.department === 4) {
                        filteredPlans = planArray.filter(
                            (item) =>
                                item.name !== "White Label" &&
                                item.name !== "Custom Branding"
                        );
                    }

                    filteredPlans.forEach((item) => {
                        temp.push({
                            value: item.id,
                            label: item.name
                        });
                    });
                }
            });

            setSelectPackageData(temp);
        }
    }, [currentWebsitePlanList, user?.department]);
    return (
        <>
            {/* <Form.Label htmlFor='package_select' aria-hidden={true}>{t("Package")}</Form.Label> */}
            <Select
                id="package_select"
                onChange={packageChange}
                options={selectPackageData}
                isMulti={user?.department === 1}
                closeMenuOnSelect={user?.department !== 1}
                backspaceRemovesValue={true}
                isClearable={true}
                isSearchable={true}
                className="aioa_dashboard-custom-domain-filter-select"
                aria-label={t("Package").toString()}
                placeholder={`${t('Select Package')}...`}
                styles={{
                    control: (base) => {
                        const darkStyles = theme === 'dark' && darkSelectStyles.control ? darkSelectStyles.control(base, { isFocused: false, isSelected: false }) : {};
                        return {
                            ...base,
                            ...darkStyles,
                            minWidth: '200px',
                            maxWidth: window.innerWidth < 768 ? '300px' : '100%',
                            minHeight: '38px'
                        };
                    },
                    valueContainer: (base) => ({
                        ...base,
                        flexWrap: 'nowrap',
                        overflowX: 'auto',
                        overflowY: 'hidden',
                        padding: '2px 8px',
                        maxHeight: '38px',
                        '&::-webkit-scrollbar': {
                            height: '4px'
                        },
                        '&::-webkit-scrollbar-track': {
                            background: 'transparent'
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: '#888',
                            borderRadius: '3px'
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                            background: '#555'
                        }
                    }),
                    multiValue: (base) => ({
                        ...base,
                        flexShrink: 0,
                        margin: '2px'
                    }),
                    multiValueLabel: (base) => ({
                        ...base,
                        whiteSpace: 'nowrap'
                    }),
                    menuList: (base) => ({
                        ...base,
                        maxHeight: '200px',
                        overflowY: 'auto'
                    }),
                    placeholder: (base) => {
                        const darkStyles = theme === 'dark' && darkSelectStyles.placeholder ? darkSelectStyles.placeholder(base) : {};
                        return {
                            ...base,
                            ...darkStyles,
                            whiteSpace: 'nowrap'
                        };
                    },
                    input: (base) => {
                        const darkStyles = theme === 'dark' && darkSelectStyles.input ? darkSelectStyles.input(base) : {};
                        return {
                            ...base,
                            ...darkStyles,
                            margin: 0,
                            padding: 0
                        };
                    },
                    menu: (base) => {
                        const darkStyles = theme === 'dark' && darkSelectStyles.menu ? darkSelectStyles.menu(base) : {};
                        return {
                            ...base,
                            ...darkStyles
                        };
                    },
                    option: (base, state) => {
                        const darkStyles = theme === 'dark' && darkSelectStyles.option ? darkSelectStyles.option(base, state) : {};
                        return {
                            ...base,
                            ...darkStyles
                        };
                    },
                    singleValue: (base) => {
                        const darkStyles = theme === 'dark' && darkSelectStyles.singleValue ? darkSelectStyles.singleValue(base) : {};
                        return {
                            ...base,
                            ...darkStyles
                        };
                    }
                }}
                value={user?.department === 1 ? selectedValues : selectedValues[0] || null}
                isOptionDisabled={() => user?.department === 1 && selectedValues.length >= 3}
            />
        </>
    )
}

export default SearchPackageDropdownBlock;